// @ts-nocheck
import Mithril from 'mithril';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';

export default class FirstLoginReputationModal extends Modal {
  className(): string {
    return 'reputation-first-login-modal';
  }

  onremove(vnode: Mithril.VnodeDOM<IInternalModalAttrs, this>) {
    super.onremove(vnode);
    const user = app.session.user;
    app.request({
      method: 'PATCH',
      url: `${app.forum.attribute('apiUrl')}/reputation/firstlogin/${user?.data?.id}`,
      data: {
        data: {
          attributes: {
            reputation_is_first_login: 0,
          },
        },
      },
    });
  }

  title(): Mithril.Children {
    return 'Reputation system guidelines';
  }

  content(): Mithril.Children {
    return (
      <div className="reputation-first-login-modal-container">
        {app.translator.trans('justoverclock-reputation-score.forum.firstLoginModalContent')}
      </div>
    );
  }
}
